<script lang="ts">
import layout from '~/consumer/layouts/DefaultLayout.vue'
export default { layout }

</script>
<script lang="ts" setup>
import PrivacyPage from '@consumer/modules/legal/PrivacyPage.vue'
</script>

<template>
  <PrivacyPage/>
</template>
